import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { createNetworkElement } from '@api/networkElements';

import { INetworkElementDTO } from '@interfaces/networkElements/dto/networkElements';
import { INetworkElement } from '@interfaces/networkElements/networkElements';

import { ESnackbarTypes } from '@enums/common';

import { NETWORK_ELEMENTS_CREATE } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

import useInvalidateNetworkElements from './useInvalidateNetworkElements';

interface IUseMutateNetworkElementsCreateReturned {
	createNetworkElement: (dto: INetworkElementDTO) => void;
	isLoadingCreateNetworkElement: boolean;
}

const useMutateNetworkElementsCreate = (handleCloseModal: () => void): IUseMutateNetworkElementsCreateReturned => {
	const invalidateNetworkElements = useInvalidateNetworkElements();
	const dispatch = useAppDispatch();

	const {
		isLoading,
		mutate,
	} = useMutation<INetworkElementDTO>({
		mutationKey: [NETWORK_ELEMENTS_CREATE],
		mutationFn: createNetworkElement,
		onSuccess: (data: INetworkElement) => {
			handleCloseModal();

			dispatch(setSnackbar({
				message: responseMessages.createNetworkElement(data.name),
				type: ESnackbarTypes.success,
			}));

			return invalidateNetworkElements();
		},
	});

	return {
		createNetworkElement: mutate,
		isLoadingCreateNetworkElement: isLoading,
	};
};

export default useMutateNetworkElementsCreate;
